import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { DossierService } from '../../services/dossier-service/dossier.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gestion-dossier',
  imports: [BreadcrumbModule,
    TableModule,
    FormsModule,
    ButtonModule,
    ToastModule,
    ToolbarModule,
    InputTextModule,
    TextareaModule,
    SelectModule,
    RadioButtonModule,
    InputNumberModule,
    DialogModule,
    TagModule,
    InputIconModule,
    IconFieldModule,
    ConfirmDialogModule, DropdownModule, CommonModule

  ],
  templateUrl: './gestion-dossier.component.html',
  styleUrl: './gestion-dossier.component.scss',
  providers: [ConfirmationService, MessageService,]

})
export class GestionDossierComponent {
  breadcrumbDossier = { icon: 'pi pi-home', routerLink: '/rechercher-do' };
  breadcrumbItems = [{ label: 'Gestion Dossier' }];
  DO: any;
  nomDo!: string;
  dossiers: any;
  rowsPerPageOptions: number[] = [10]; // Valeur par défaut
  totalRecords: number = 10;
  loading: boolean = true;
  selectedDossiers!: any;
  DetailsDialog: boolean = false;
  selectedDossierItem: any;
  dossier: any;

  @ViewChild('filter') filter!: ElementRef;
  @ViewChild('dt1', { static: false }) dt1!: Table;

  constructor(
    private dossierService: DossierService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    let selectedDoString = sessionStorage.getItem('selectedDo');
    if (selectedDoString) {
      let selectedDo = JSON.parse(selectedDoString);
      this.DO = selectedDo.code_interne;
      this.nomDo = selectedDo.Nom;


      this.loadData();


    } else {
      this.router.navigate(['/rechercher-do']);
    }
  }

  loadData() {
    this.dossierService.getDossiersByDo(this.DO).subscribe({
      next: (data: any) => {
        this.dossiers = data;
        //console.log(this.dossiers)
        this.totalRecords = data.length;
        this.updateRowsPerPageOptions();
        this.loading = false;
      }
    });
  }
  updateRowsPerPageOptions() {
    const baseOptions = [10, 20, 30, 40, 50];

    // Limitez les options supplémentaires à des valeurs raisonnables
    const maxReasonableOption = 100; // Définissez une limite supérieure raisonnable

    if (this.totalRecords > 50) {
      const additionalOptions = [];
      // Ajoutez des options jusqu'à la limite raisonnable ou au totalRecords (le plus petit des deux)
      const upperLimit = Math.min(this.totalRecords, maxReasonableOption);

      for (let i = 100; i <= upperLimit; i += 100) {
        additionalOptions.push(i);
      }

      this.rowsPerPageOptions = [...baseOptions, ...additionalOptions];
    } else {
      this.rowsPerPageOptions = baseOptions;
    }

    // Ajoutez le totalRecords seulement s'il est raisonnable et différent des options existantes
    if (this.totalRecords <= maxReasonableOption &&
      !this.rowsPerPageOptions.includes(this.totalRecords)) {
      this.rowsPerPageOptions.push(this.totalRecords);
    }
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  clear(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }


  calculateCustomerTotal(name: string) {
    let total = 0;

    if (this.dossiers) {
      for (let dossier of this.dossiers) {
        if (dossier.service === name) {
          total++;
        }
      }
    }

    return total;
  }

  hideDialog() {
    this.DetailsDialog = false;
  }

  openDetailsDossier(dossier: any) {
    this.selectedDossierItem = dossier;
    this.DetailsDialog = true;
  }
  deleteSelectedDossiers() {
    this.confirmationService.confirm({
      message: 'Confirmez la suppression ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.confirmationService.close?.();
        if (!this.selectedDossiers || this.selectedDossiers.length === 0) {
          console.warn('Aucune sélection');
          return;
        }
        const codes = this.selectedDossiers.map((a: any) => a.code_interne);
        this.dossierService.DeleteOneOrManyDossiers(codes).subscribe(
          (data: any) => {

            this.loadData();
            this.messageService.add({
              severity: 'success',
              summary: 'Réussi',
              detail: `${codes.length} dossier(s) supprimé(s)`,
              life: 3000
            });
            this.selectedDossiers = null

          });
      },
      reject: () => {
        this.confirmationService.close?.();
      }
    });




  }

  deleteByOne(dossier: any) {

    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer ce dossier?',
      header: 'Confirmer',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.confirmationService.close?.();
        this.dossierService.DeleteOneOrManyDossiers([dossier.code_interne]).subscribe(
          (result: any) => {

            this.loadData();
            this.messageService.add({
              severity: 'success',
              summary: 'Réussi',
              detail: `Dossier ${dossier.code_interne} supprimé !`,
              life: 3000
            });
          },
          (error) => {
            console.error(error)
          }
        )

      },
      reject: () => {
        this.confirmationService.close?.();
      }
    });
  }
 ExporterDossiersCSV() {
  this.dossierService.exportDossierByDo(this.DO).subscribe({
    next: (blob: Blob) => {
      const reader = new FileReader();
      reader.onload = () => {
        const text = reader.result as string;
        const bom = '\uFEFF'; // BOM UTF-8
        const blobWithBom = new Blob([bom + text], { type: 'text/csv;charset=utf-8;' });

        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blobWithBom);
        a.href = objectUrl;
        a.download = `${this.DO}_Export_Dossiers.csv`;
        a.click();
        URL.revokeObjectURL(objectUrl);
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Fichier téléchargé' });
      };
      reader.readAsText(blob); // ✅ plus d’erreur ici
    },
    error: (err) => {
      console.error('Erreur lors du téléchargement :', err);
      this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'L\'export a échoué' });
    },
  });
}

}
